export const VOCATIONS = [
  {
    id: 'army',
    short: 'ARMY',
    name: 'Singapore Army',
    verb: 'VOLUME',
    commons: 'groundHold',
    commonsLabel: 'GROUND HOLD',
    description: 'Bulk output and steady posture. The generator class; every sector feels a little more held.',
    units: [
      ['Recruit', 'Area cleaning, guard duty, stores.'], ['Section', 'A small team that can hold a routine.'], ['Platoon', 'The first formation with real reach.'], ['Company', 'A proper unit, properly accounted for.'], ['Battalion', 'The paperwork has become operational.'], ['Mechanised Line', 'Mobility, coordination, and more forms.'], ['Armour Squadron', 'Volume starts to look like posture.'], ['Combined Arms Division', 'A national-scale answer to a national-scale problem.'],
    ],
  },
  {
    id: 'rsn',
    short: 'RSN',
    name: 'Republic of Singapore Navy',
    verb: 'SUSTAIN',
    commons: 'supply',
    commonsLabel: 'SUPPLY',
    description: 'Keeps the sea lanes and the lights on. Your Supply commons gently lifts everyone’s output.',
    units: [
      ['Harbour Craft', 'Short routes, long days, dependable coffee.'], ['Patrol Boat', 'A visible answer on a usually quiet sea.'], ['Littoral Mission Vessel', 'Flexible reach around the island approaches.'], ['Missile Corvette', 'A compact formation with serious paperwork.'], ['Frigate', 'Longer endurance for a longer watch.'], ['Submarine', 'Quiet work beneath the shipping picture.'], ['Landing Ship', 'Moves what the island needs, when it needs it.'], ['Maritime Task Force', 'The sea lane becomes a national system.'],
    ],
  },
  {
    id: 'rsaf',
    short: 'RSAF',
    name: 'Republic of Singapore Air Force',
    verb: 'TEMPO',
    commons: 'readiness',
    commonsLabel: 'READINESS',
    description: 'Fast, reactive, and already turning toward the signal. Readiness shortens event windows.',
    units: [
      ['Ground Crew', 'The aircraft starts with the people on the ground.'], ['UAV Flight', 'Persistent eyes over a very busy island.'], ['Transport Section', 'Moves crews and kit before the map catches up.'], ['Helicopter Squadron', 'Flexible lift for an island with no spare time.'], ['Fighter Flight', 'A quick answer to an unclear track.'], ['Fighter Squadron', 'Speed becomes a formation.'], ['Air Defence Battery', 'The horizon is a system, not a line.'], ['Integrated Air Wing', 'Every corridor covered, every signal considered.'],
    ],
  },
  {
    id: 'dis',
    short: 'DIS',
    name: 'Digital and Intelligence Service',
    verb: 'INFORM',
    commons: 'intel',
    commonsLabel: 'INTEL',
    description: 'Acts on information before the event arrives. Intel reveals watches early and cuts waste.',
    units: [
      ['Signals Operator', 'The first person to notice the signal is odd.'], ['Analyst Cell', 'Patterns emerge when someone keeps the notes.'], ['Security Operations Centre', 'A watch floor that never really sleeps.'], ['Cyber Defence Group', 'Hardens the ordinary systems people rely on.'], ['Signals Array', 'A wider net for quieter anomalies.'], ['Threat Hunt Team', 'Finds the thing that thought it was hiding.'], ['Fusion Centre', 'Several partial pictures become one useful one.'], ['Predictive Intelligence Grid', 'The next event gets a lead-time stamp.'],
    ],
  },
];

export const UNIT_BASES = [
  { tier: 1, cost: 15, output: 0.1, unlock: 1 },
  { tier: 2, cost: 100, output: 1, unlock: 1 },
  { tier: 3, cost: 1100, output: 8, unlock: 2 },
  { tier: 4, cost: 12000, output: 47, unlock: 3 },
  { tier: 5, cost: 130000, output: 260, unlock: 4 },
  { tier: 6, cost: 1400000, output: 1400, unlock: 5 },
  { tier: 7, cost: 20000000, output: 7800, unlock: 7 },
  { tier: 8, cost: 330000000, output: 44000, unlock: 9 },
];

export function vocationFor(id) { return VOCATIONS.find((vocation) => vocation.id === id) || VOCATIONS[0]; }

export function unitsForVocation(id) {
  const vocation = vocationFor(id);
  return UNIT_BASES.map((base, index) => ({ ...base, name: vocation.units[index][0], detail: vocation.units[index][1] }));
}
